<div class="devices-container">
  <div class="flex justify-content--space-between">
    <app-search (onSearch)="searchDevices($event)"></app-search>
    <div class="toggle-button">
      <input type="checkbox" [(ngModel)]="isGroupDisplay" [ngModelOptions]="{standalone: true}" id="display" />
      <label for="display" class="flat-list-button" [ngClass]="{'clicked': !isGroupDisplay, 'not-clicked': isGroupDisplay}">flat list</label>
      <label for="display" class="grouped-list-button" [ngClass]="{'clicked': isGroupDisplay, 'not-clicked': !isGroupDisplay}">by group</label>
    </div>
  </div>
  <div class="flex justify-content--space-between">
    <div class="devices-table">
      <div *ngIf="devices$ | async; else emptyTable">
        <app-grouped-list [isGroupDisplay]="isGroupDisplay"></app-grouped-list>
      </div>
      <ng-template #emptyTable>
        <div>no devices</div>
      </ng-template>
    </div>
    <div [@enterAnimation] class="selected-items" *ngIf="(selectedOutput$ | async) || (selectedGroup$ | async)">
      <app-selected-output></app-selected-output>
      <app-selected-group></app-selected-group>
    </div>
  </div>
</div>